import { dollars } from '@nuts/auto-delivery-sdk/dist/utils/money';

import { NutsLineItem } from '@/lib/cart/lineItem';
import { cartViewed } from '@/rudder-typer';
import { formatPurchaseItem, gtag } from '@/utils/analytics';
import { formatStandardProductsItem } from '@/utils/analytics/rudderstack';
import { Taggstar } from '@/utils/analytics/taggstar';
import { Money } from '@/utils/money';

export function sendCartViewedEvent(
  lineItems: NutsLineItem[],
  total: Money,
  location: string,
  cartId?: string,
) {
  gtag('event', 'view_cart', {
    location,
    currency: 'USD',
    value: dollars(total),
    items: lineItems.map(formatPurchaseItem),
  });

  if (lineItems.length) {
    Taggstar.basketVisit({
      lines: lineItems.map((item) => ({
        category: item.variant.attributes?.find((attr) => attr.name === 'reportingCategory')?.value
          .key,
        id: item.productKey,
        price: dollars(item.piecePrice),
        quantity: item.quantity,
      })),
    });

    cartViewed({
      cart_id: cartId,
      products: lineItems.map((lineItem) => formatStandardProductsItem(lineItem)),
      total: dollars(total),
    });
  }
}
